import Collapse03 from './Collapse03';
export default Collapse03;
